/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { z } from 'zod';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

/**
 * @description Checks if a passed value is a valid ISO 8601 date string.
 * @param value
 */
var checkIsIsoDate = function checkIsIsoDate(value) {
  return z.string().refine(function (value) {
    if (typeof value !== 'string') {
      return false;
    }
    var parsedDate = dayjs.utc(value, 'YYYY-MM-DDTHH:mm:ssZ', true);
    return parsedDate.isValid();
  }, {
    message: 'Invalid ISO date'
  }).safeParse(value).success;
};

export { checkIsIsoDate };
//# sourceMappingURL=check-is-iso-date.js.map
